import { NavigateBefore } from '@mui/icons-material';
import { Box, Breadcrumbs, Button, Grid, Link, SxProps, Tab, Tabs, Theme, Typography } from '@mui/material';
import { useCallback, useState, ChangeEvent as ReactChangeEvent } from 'react';
import { useRouteMatch, Link as ReactRouterLink, useParams, useLocation, useHistory } from 'react-router-dom';
import { useQueryContracts } from 'shared/queries/query-contracts';
import { ContractRouteParams } from 'shared/types/routing';

const breadcrumbContentStyles: SxProps<Theme> = {
  padding: 2,
};

export function CustomerDetailsNavigationHeader() {
  const { masterCustomer, abgBrand } = useParams<ContractRouteParams>();
  const { contracts } = useQueryContracts({ brand: abgBrand, customer: masterCustomer });
  const location = useLocation();
  const currentTab = location.pathname.includes('contractSummary') ? 'contractSummary' : 'viewContracts';
  const { url } = useRouteMatch();
  const [activeTab, setActiveTab] = useState(currentTab);
  const history = useHistory();

  const tabChange = useCallback((event: ReactChangeEvent<{}>, value: string) => {
    setActiveTab(value);
  }, []);

  const toCustomerManagementList = useCallback(() => {
    history.push('/customer-management');
  }, [history]);

  const tabBreadcrumbDisplayText = currentTab === 'contractSummary' ? 'Contract Summary' : 'View Contracts';

  const disabledContractTab = !Boolean(contracts?.length);

  return (
    <>
      <Grid container justifyContent='flex-start'>
        <Link
          sx={{ margin: '15px', marginBottom: 0 }}
          variant='subtitle1'
          underline='none'
          color='textSecondary'
          onClick={toCustomerManagementList}
        >
          <Button startIcon={<NavigateBefore />} onClick={toCustomerManagementList} variant='outlined'>
            Go back
          </Button>
        </Link>
      </Grid>
      <Box sx={breadcrumbContentStyles}>
        <Box style={{ display: 'flex', justifyContent: 'space-between', flexFlow: 'row' }}>
          <Breadcrumbs separator='>' aria-label='customer overview'>
            <Link component={ReactRouterLink} underline='hover' color='inherit' to='/customer-management'>
              Customer Management
            </Link>
            <Typography color='text.primary'>{tabBreadcrumbDisplayText}</Typography>
          </Breadcrumbs>
        </Box>
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={tabChange}
          textColor='secondary'
          indicatorColor='secondary'
          aria-label='customer details'
        >
          <Tab
            value='contractSummary'
            label='Contract Summary'
            component={ReactRouterLink}
            to={`${url}/contractSummary`}
          />
          <Tab
            disabled={disabledContractTab}
            value='viewContracts'
            label={disabledContractTab ? 'No Contracts' : 'View Contracts'}
            component={ReactRouterLink}
            to={`${url}/viewContract/${contracts?.[0]?.id}`}
          />
          {/* <Tab value='viewProductPrices' label='View Product Prices' /> */}
        </Tabs>
      </Box>
    </>
  );
}
